import React, { useEffect, useState } from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Checkbox, Divider } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import CircularProgress from '@mui/material/CircularProgress';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import '../css/PoolChecklist.css';
import MinerIcon from '../icons/miner_icon.png';

function PoolChecklist({ onPoolSelection, pools }) {
    const [poolNames, setPoolNames] = useState([]);
    const [checkedPools, setCheckedPools] = useState({});
    const [selectAll, setSelectAll] = useState(true);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setPoolNames(Object.keys(pools));
        setCheckedPools(Object.keys(pools).reduce((acc, pool) => ({ ...acc, [pool]: true }), {}));
    }, [pools]);

    // Initialize with all pools selected and notify parent component
    useEffect(() => {
        if (poolNames.length > 0) {
            const allPoolsSelected = poolNames.reduce((acc, pool) => ({ ...acc, [pool]: true }), {});
            onPoolSelection(allPoolsSelected);
        }
    }, [poolNames]); // Removed onPoolSelection dependency to avoid unnecessary re-renders

    useEffect(() => {
        setCheckedPools(poolNames.reduce((acc, pool) => ({ ...acc, [pool]: selectAll }), {}));
    }, [selectAll, poolNames]);

    const handleCheckboxChange = (pool) => {
        const updatedCheckedPools = { ...checkedPools, [pool]: !checkedPools[pool] };
        setCheckedPools(updatedCheckedPools);
        onPoolSelection(updatedCheckedPools);
    };

    const handleSelectAllChange = () => {
        setSelectAll(!selectAll);
        onPoolSelection(poolNames.reduce((acc, pool) => ({ ...acc, [pool]: !selectAll }), {}));
    };


    return (
        <>
            {/* Button to open the dialog */}
            <Button
                variant="contained"
                onClick={() => setOpen(true)}
                sx={{
                    width: '80px',
                    height: '50px',
                    backgroundColor: 'inherit', // Adjust background color here
                    '&:hover': {
                        backgroundColor: '#ff5050', // Adjust hover background color here
                    },
                }}
                className="openButton"
            >
                <span style={{ fontSize: '16px' }}>Pools</span>
            </Button>


            {/* Dialog that contains the checklist */}
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="sm"
                fullWidth
                classes={{ paper: 'dialogPaper' }} // Apply custom class to Dialog's Paper component
            >
                <DialogTitle className="dialogTitle">Select Pools</DialogTitle>
                <DialogContent className="dialogContent">
                    {
                        !Object.keys(pools).length ? <CircularProgress className='my-8' /> : <List>
                            {/* Checkbox for selecting all pools */}
                            <ListItem
                                button
                                onClick={handleSelectAllChange}
                                className="listItem"
                            >
                                <ListItemIcon>
                                    <Checkbox
                                        edge="start"
                                        checked={selectAll}
                                        tabIndex={-1}
                                        disableRipple
                                        className="listItemCheckbox"
                                    />
                                </ListItemIcon>
                                <ListItemText primary="Select All" />
                            </ListItem>
                            <Divider />

                            {/* Mapping over each pool to create a list item */}
                            {poolNames.map(pool => (
                                <ListItem
                                    key={pool}
                                    button
                                    onClick={() => handleCheckboxChange(pool)}
                                    className="listItem"
                                >
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            checked={checkedPools[pool]}
                                            tabIndex={-1}
                                            disableRipple
                                            className="listItemCheckbox"
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary={pool} />
                                </ListItem>
                            ))}
                        </List>
                    }

                </DialogContent>
            </Dialog>
        </>
    );

}

export default PoolChecklist;
